module.exports = __webpack_public_path__ + "static/media/dinersclub-logo.7bab2c5e.svg";